module.exports = __webpack_public_path__ + "static/img/v78DetailImg.70ef92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v78DetailImg.png
// module id = A5d1
// module chunks = 1